import { gql } from "@apollo/client";

// SLA opt-in of node and region subscriptions, kept out of the regular list
// queries: the query is skipped while the SLA flag is off, so a flag-off build
// never sends a field an older gateway rejects.
export const InstalledBaseSubscriptionsSla = gql`
    query InstalledBaseSubscriptionsSla {
        installedBaseNodeSubscriptionList {
            subscriptions(pagination: { limit: 100, start: 0 }) {
                id
                slaStatusChange
            }
        }
        installedBaseRegionSubscriptionList {
            subscriptions(pagination: { limit: 100, start: 0 }) {
                id
                slaStatusChange
            }
        }
    }
`;
